import { components } from "react-select";
import { ReactComponent as DownIconGrey } from "../assets/icons/down_grey.svg";

const CustomDropdownIndicatorGrey = (props) => {
  return (
    <components.DropdownIndicator {...props}>
      <DownIconGrey  />
    </components.DropdownIndicator>
  );
};
export default CustomDropdownIndicatorGrey;